import { render, staticRenderFns } from "./ComplianceFormOverview.vue?vue&type=template&id=97eb3b3a&"
import script from "./ComplianceFormOverview.vue?vue&type=script&lang=js&"
export * from "./ComplianceFormOverview.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceFormOverview.vue?vue&type=style&index=0&id=97eb3b3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports